import React, { forwardRef } from "react";
import {
  AddCircle,
  Search,
  DeleteOutline,
  Clear,
  Check,
  CheckBoxOutlined,
  CheckBoxOutlineBlank,
  Save,
  ZoomIn,
  ZoomOut,
  LockOpenOutlined,
  EditOutlined,
  VisibilityOutlined,
  Lock,
} from "@material-ui/icons";
import { green } from "@material-ui/core/colors";
import { CircularProgress } from "@material-ui/core";

function useTableIcons() {
  const tableIcons = {
    Add: forwardRef((props, ref) => (
      <AddCircle {...props} ref={ref} color="primary" fontSize="large" />
    )),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => (
      <DeleteOutline {...props} ref={ref} color="error" />
    )),
    Clear: forwardRef((props, ref) => (
      <Clear {...props} ref={ref} color="error" />
    )),
    Check: forwardRef((props, ref) => (
      <Check {...props} ref={ref} style={{ color: green[500] }} />
    )),
    CheckBox: forwardRef((props, ref) => (
      <CheckBoxOutlined {...props} ref={ref} />
    )),
    CheckBoxBlank: forwardRef((props, ref) => (
      <CheckBoxOutlineBlank {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <EditOutlined {...props} ref={ref} />),
    Save: forwardRef((props, ref) => <Save {...props} ref={ref} />),
    Progress: forwardRef((props, ref) => (
      <CircularProgress {...props} ref={ref} size={14} />
    )),
    View: forwardRef((props, ref) => (
      <VisibilityOutlined {...props} ref={ref} />
    )),
    ZoomIn: forwardRef((props, ref) => <ZoomIn {...props} ref={ref} />),
    ZoomOut: forwardRef((props, ref) => <ZoomOut {...props} ref={ref} />),
    Permission: forwardRef((props, ref) => (
      <LockOpenOutlined {...props} ref={ref} />
    )),
    Lock: forwardRef((props, ref) => <Lock {...props} ref={ref} />),
  };
  return { tableIcons };
}
export default useTableIcons;
